export const types = {
    DRAG_INDEX: 'drag_index',
    DROP_INDEX: 'drop_index',
    NEEDS_REFRESH: 'needs_refresh'
};

export function setDragTarget(index) {
    return { type: types.DRAG_INDEX, index};
}

export function setDropTarget(index) {
    return { type: types.DROP_INDEX, index};
}

export function needsRefresh(value) {
    return { type: types.NEEDS_REFRESH, value};
}



/** WEBPACK FOOTER **
 ** ./src/actions/SlideViewerActions.js
 **/